angular
  .module('contrast.organization.restore', [
    'ngRoute',
    'ngAnimate',
    'route-segment',
    'view-segment',
    'ui.bootstrap',
    'dialogs.main'
  ])
  .controller(
    'RestoreCtrl',
    function (
      $scope,
      dialogs,
      $window,
      logger,
      OrganizationFactory,
      ErrorService,
      permissions
    ) {
      $scope.userSettings = {}
      $scope.userSettings.isImpersonating = permissions.isImpersonating()

      $scope.$on('profile:loaded', function () {
        $scope.userSettings.isImpersonating = permissions.isImpersonating()
      })

      $scope.restore = function () {
        var dlg = null
        dlg = dialogs.confirm(
          'Please Confirm',
          'Are you sure you want to restore admin portal session?',
          {
            size: 'sm',
            yes: 'Restore'
          }
        )
        dlg.result.then(function () {
          OrganizationFactory.restoreSuperadminSession().then(
            function (response) {
              var data = response.data
              logger.logSuccess(data.messages[0])
              switch (data.redirectTo) {
                case 'ORGS_MODE':
                  $window.location.href =
                    '/Contrast/static/ng/admin_index.html#/superadmin/organizations'
                  break
                case 'USERS_MODE':
                  $window.location.href =
                    '/Contrast/static/ng/admin_index.html#/superadmin/users'
                  break
                default:
                  $window.location.href =
                    '/Contrast/static/ng/admin_index.html#/superadmin/organizations'
                  break
              }
            },
            function (response) {
              ErrorService.processError(response)
            }
          )
        })
      }
    }
  )
